import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { FilterRealSeason } from 'src/app/classes/filterRealSeason';
import { Pagination } from 'src/app/classes/pagination';
import { AlertboxComponent } from 'src/app/general/alertbox/alertbox.component';
import { RealCompetitionService } from 'src/app/services/real-competition.service';
import { RealSeasonService } from 'src/app/services/real-season.service';

@Component({
  selector: 'app-realseason-list',
  templateUrl: './realseason-list.component.html',
  styleUrls: ['./realseason-list.component.scss']
})
export class RealseasonListComponent implements OnInit {

  subscription: any;
  pathList: Array<Array<string>>;
  bcRightValue: Array<Array<number>>;
  busy: Subscription;
  unsubscribe$: Subscription;
  list: any;
  faPlus = faPlusCircle;
  faTrash = faTrashAlt;
  listPagination: Pagination;
  filterRealSeason: FilterRealSeason
  cols: string[];
  searchForm = this.fb.group({});
  rcomp_list: any
  maxSize = 15
  @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;

  constructor(private router: Router, public realSeasonService: RealSeasonService, public realCompetitionService: RealCompetitionService,  private fb: FormBuilder) {
    this.pathList = [['Real Seasons', 'real_season/list']];
  }

  formControlsNames(form) {
    return Object.keys(form);
  }

  add(a: Alert) {
    this.alertbox1.alerts.push(a);
  }
  page_nr($event) {
    this.searchForm.controls['ctrl_page'].setValue($event);
    this.getList();
  }
  getList() {
    let filter: Array<any> | null = null;
    if(this.searchForm.value) {
      filter = [];
    }
    for (const key in this.searchForm.value) {
      if (Object.prototype.hasOwnProperty.call(this.searchForm.value, key)) {
        const element = this.searchForm.value[key];
        if ((element || element == '') && element != 'null') {
          const itemKey = key.split('_')
          itemKey.shift();
          filter[itemKey.join('_')] = element;
          this.filterRealSeason['ctrl_' + itemKey.join('_')] = element;
        }
      }
    }
    filter['limit'] = this.maxSize;
        if(!filter['page']){
            filter['page'] = 1
    }
    this.realSeasonService.setFilterObs(this.filterRealSeason)
    this.busy = this.realSeasonService.list2(filter).subscribe({
      next: (data) => {
        this.list = data.payload;
        this.listPagination = data.pagination

        this.cols = [ "id", "description", 'startDate', 'endDate'];
        for (const col of this.cols) {
          this.searchForm.addControl('ctrl_' + col, new FormControl('', Validators.required))
        }

      },
      error: (err) => console.log('ERRORE: ' + JSON.stringify(err.error.description)),
    });
  }

  deleteItem(id: number) {
    if (+id > 0) {
      this.busy = this.realSeasonService.delete(id).subscribe({
        next: () => this.getList(),
        error: (err) => console.log(err),
      });
    }
  }

  navigateTo(id: any) {
    this.router.navigate([`/real_season/${id}`]);
  }

  dialogConfirm(id) {
    if (+id > 0) {
      this.deleteItem(id);
    }
  }

  ngOnInit(): void {

    this.cols = [ "id", "description", "startDate", "endDate"];
    this.searchForm.addControl('ctrl_page', new FormControl('', Validators.required))
    for (const col of this.cols){
      this.searchForm.addControl('ctrl_' + col, new FormControl('', Validators.required))
    }
    this.unsubscribe$ = this.realSeasonService.getFilterObs().subscribe(filter => {
      this.filterRealSeason = filter;
      this.searchForm.controls['ctrl_page'].setValue(this.filterRealSeason.ctrl_page);
      this.searchForm.controls['ctrl_description'].setValue(this.filterRealSeason.ctrl_description);
      this.searchForm.controls['ctrl_id'].setValue(this.filterRealSeason.ctrl_id);
      this.searchForm.controls['ctrl_startDate'].setValue(this.filterRealSeason.ctrl_startDate);
      this.searchForm.controls['ctrl_endDate'].setValue(this.filterRealSeason.ctrl_endDate);
    });
    this.getList();
    // this.getRealCompetitions();
  }

  // getRealCompetitions(){
  //   this.busy = this.realSeasonService.getSeasonRealcompetitions().subscribe({
  //       next: (data) => this.rcomp_list = data.payload,
  //       error: (err) => console.log(err),
  //     });
  // }
}
